if (!customElements.get('video-hero')) {
  class VideoHero extends HTMLElement {
    constructor() {
      super();
      this.media = null;
      this.video = null;
      this.parallaxEnabled = false;
      this.rafId = null;
      this.observer = null;
      this.isVisible = false;
      this.desktopQuery = window.matchMedia('(min-width: 750px)');
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    }

    connectedCallback() {
      this.media = this.querySelector('[data-media]');
      this.video = this.querySelector('video');
      this.parallaxEnabled = this.hasAttribute('data-parallax') && !this.reducedMotion.matches;

      this.setupVisibilityObserver();
      this.setupMediaHandling();

      if (this.parallaxEnabled) {
        this.setupParallax();
      }

      // Trigger reveal animation
      requestAnimationFrame(() => this.classList.add('video-hero--revealed'));
    }

    disconnectedCallback() {
      if (this.rafId) cancelAnimationFrame(this.rafId);
      if (this.observer) this.observer.disconnect();
      if (this._scrollHandler) window.removeEventListener('scroll', this._scrollHandler);
      if (this._mediaHandler) this.desktopQuery.removeEventListener('change', this._mediaHandler);
    }

    setupVisibilityObserver() {
      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            this.isVisible = entry.isIntersecting;
            if (this.video) {
              if (entry.isIntersecting && this.desktopQuery.matches) {
                this.video.play().catch(() => {});
              } else {
                this.video.pause();
              }
            }
          });
        },
        { threshold: 0.1 }
      );
      this.observer.observe(this);
    }

    setupMediaHandling() {
      if (!this.video) return;

      this._mediaHandler = (e) => {
        if (e.matches && this.isVisible) {
          this.video.play().catch(() => {});
        } else {
          this.video.pause();
        }
      };
      this.desktopQuery.addEventListener('change', this._mediaHandler);

      // Pause on mobile initially
      if (!this.desktopQuery.matches) {
        this.video.pause();
      }
    }

    setupParallax() {
      const tick = () => {
        if (!this.isVisible || !this.media) return;
        const rect = this.getBoundingClientRect();
        const vh = window.innerHeight;
        const progress = (vh - rect.top) / (vh + rect.height);
        const clamped = Math.max(0, Math.min(1, progress));
        // Travel range: -10% to +10% (20% total range of the 120% media)
        const translate = (clamped - 0.5) * 20;
        this.media.style.transform = `translateY(${translate}%)`;
      };

      this._scrollHandler = () => {
        if (this.rafId) cancelAnimationFrame(this.rafId);
        this.rafId = requestAnimationFrame(tick);
      };

      window.addEventListener('scroll', this._scrollHandler, { passive: true });
      tick(); // Initial position
    }
  }

  customElements.define('video-hero', VideoHero);
}
